module.exports = __webpack_public_path__ + "img/section4_m.cbc67527.jpg";